/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { makeStyles } from 'tss-react/mui';

import * as React from 'react';

export function DialogButtonsList({children}) {
  return <div className={styles().DialogButtonsList}>{children}</div>;
}

export function DialogActions({
  'data-test-id': dataTestId,
  children,
}) {
  return (
    <div className={styles().DialogActions} data-test-id={dataTestId}>
      {children}
    </div>
  );
}


const styles = makeStyles()(theme => ({
  DialogActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "right",
    marginTop: "20px"
  },
  DialogButtonsList: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "right",
    marginTop: "20px",
  },
  DialogButtonsList: {
    " & > button": {
      marginBottom: "20px"
    }
  }
}))
